document.addEventListener('DOMContentLoaded', () => {
  // Add product to wishlist on button click
  console.log('wishlist script loaded');
  document.querySelectorAll('[data-add-to-wishlist]').forEach(button => {
    const productHandle = button.getAttribute('data-product-handle');
    // const wishlistBanner = document.getAttribute('data-remove-wishlist');
    getWishlist().includes(productHandle) ? button.classList.add('active') : button.classList.remove('active');
    button.addEventListener('click', function(el) {
      let productHandle = el.currentTarget.dataset.productHandle;
      if(this.classList.contains('active')) {
        removeFromWishlist(productHandle);
        this.classList.remove('active');
      } else {
        addToWishlist(productHandle);
        this.classList.add('active');
      }
    });
  });
  updateWishlistCount(getWishlist());
});
// document.addEventListener('DOMContentLoaded', () => {
//   // Add product to wishlist on button click
//   console.log('wishlist script loaded');
//   document.querySelectorAll('[data-add-to-wishlist]').forEach(button => {
//     const productHandle = button.getAttribute('data-product-handle');
//     // Remove the wrong wishlistBanner assignment here
//     getWishlist().includes(productHandle) ? button.classList.add('active') : button.classList.remove('active');
//     button.addEventListener('click', function(el) {
//       let productHandle = el.currentTarget.dataset.productHandle;
//       const parent = this.parentElement;
//       // Find .custom-icon-box inside parent
//       const iconBox = parent.querySelector('.custom-icon-box');
//       // Find [data-remove-wishlist] inside .custom-icon-box
//       const removeWishlist = iconBox ? iconBox.querySelector('[data-remove-wishlist]') : null;

//       if(this.classList.contains('active')) {
//         removeFromWishlist(productHandle);
//         this.classList.remove('active');
//         // If found, set text to "Add to Wishlist"
//         if(removeWishlist) {
//           removeWishlist.textContent = "Remove from Wishlist";
//         }
//       } else {
//         addToWishlist(productHandle);
//         this.classList.add('active');
//         // If found, set text to "Remove from Wishlist"
//         if(removeWishlist) {
//           removeWishlist.textContent = "Add to Wishlist";
//         }
//       }
//     });
//   });
//   updateWishlistCount(getWishlist());
// });

// updated wishlist script
function updateWishlistCount(wishlist) {
  const countElem = document.querySelector('.header__cart-dot .cart-count');
  if (!countElem) return;
  countElem.textContent = wishlist.length;
}

function getWishlist() {
  const wishlist = localStorage.getItem('myShopifyWishlist');
  return wishlist ? JSON.parse(wishlist) : [];
}

function saveWishlist(wishlist) {
  localStorage.setItem('myShopifyWishlist', JSON.stringify(wishlist));
}

function addToWishlist(productHandle) {
  if (!productHandle) return; // Do nothing if the handle is invalid

  let wishlist = getWishlist();
  if (!wishlist.includes(productHandle)) {
    wishlist.push(productHandle);
    saveWishlist(wishlist);
    console.log(`Added: ${productHandle}`);
  } else {
    console.log(`Already in wishlist: ${productHandle}`);
  }
  updateWishlistCount(wishlist);
}

function removeFromWishlist(productHandle,cardAction) {
  if (!productHandle) return; // Do nothing if the handle is invalid
  let wishlist = getWishlist();
  const newWishlist = wishlist.filter(handle => handle !== productHandle);

  saveWishlist(newWishlist);
  console.log(`Removed: ${productHandle}`);
  if(cardAction){
    event.target.closest('product-card').remove()
  }
  updateWishlistCount(getWishlist());
}